
export default {
  name: 'FooterCopyright',
  data() {
    return {
      year: '',
      links: [
        { name: 'Privacy Policy', slug: '/privacy-policy' },
        { name: 'Terms of Use', slug: '/terms-and-conditions' },
      ],
    };
  },
  created() {
    this.year = new Date().getFullYear();
  },
  methods: {
    handleClick(link, event) {
      if (process.client) {
        event.preventDefault();
        event.stopPropagation();

        const currentSlug = this.$route.path[0] === '/' ? this.$route.path.slice(1) : this.$route.path;
        if (link.slug.includes(currentSlug)) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        }
      }
    },
  },
  computed: {
    isCheckoutPage() {
      return this.$route.name === 'onepage';
    },
  },
};
